export default __webpack_public_path__ + "static/media/s2.a93e9bf2.png";